import React, { Fragment } from "react";
import { Table, Card } from "react-bootstrap";
import _ from "lodash";
import { getFormattedDate } from "../../util/helpers";

export const OrganizationDetails = ({ organizationDetails }) => {
  const sortedOrganizationDetails = _.orderBy(
    organizationDetails,
    ["joiningDate"],
    ["desc"]
  );
  return (
    <div className="container mt-3">
      <Card.Header className="accordian-header">ORGANIZATION</Card.Header>
      <div className="container mt-3">
        {sortedOrganizationDetails && sortedOrganizationDetails.length ? (
          sortedOrganizationDetails.map(function (org, id) {
            return (
              <div key={id}>
                <div className="container mt-3">
                  <h6 className="text-left">
                    {id === 0
                      ? "Current Organization"
                      : "Previous Organization"}
                  </h6>
                  <div className="container mt-3">
                    <div className="col report text-center">
                      <Table striped bordered hover size="sm">
                        <tr>
                          <td align="left">
                            <strong>Name : </strong>
                            {org.organizationName}
                          </td>
                          <td align="left" colSpan="2">
                            <strong>Job Title : </strong>
                            {org.jobTitle}
                          </td>
                        </tr>
                        <tr>
                          <td align="left">
                            <strong>Location : </strong>
                            {org.location}
                          </td>
                          <td align="left">
                            <strong>Date of Joining : </strong>
                            {getFormattedDate(org.joiningDate)}
                          </td>
                          <td align="left">
                            <strong>Last Working Day : </strong>
                            {getFormattedDate(org.lastWorkingDate)}
                          </td>
                        </tr>
                        <tr>
                          <td align="left">
                            <strong>Department : </strong>
                            {org.departmentName}
                          </td>
                          <td align="left" colSpan="2">
                            <strong>Employee Code : </strong>
                            {org.employeeCode}
                          </td>
                        </tr>
                      </Table>
                    </div>
                  </div>

                  <br />
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-center">Organization Details are not available</p>
        )}
      </div>
    </div>
  );
};

export default OrganizationDetails;
